module.exports = __webpack_public_path__ + "static/media/Vancis.bbcc5454.png";